import { type TFunction } from "i18next";
import {
  type FieldValues,
  type Path,
  type UseFormGetValues,
} from "react-hook-form";
import { type CheckboxGroupFieldValidationOptions } from "@/components/common/formElements/hooks/useCheckboxGroupFieldController";

export function applyCheckboxGroupValidationOptions<
  TFieldValues extends FieldValues,
>(
  name: Path<TFieldValues>,
  getValues: UseFormGetValues<TFieldValues>,
  t: TFunction,
  rules: CheckboxGroupFieldValidationOptions<TFieldValues> = {},
) {
  // If this rule selected check that you will trigger validation in child components
  // in case of changing for this rule
  if (rules.required) {
    rules.validate = {
      hasAtLeastOneSelectedCheckbox() {
        const checkboxInputs =
          (getValues(name) as { [key: string]: unknown }) || {};
        const selectedOptions = Object.values(checkboxInputs).filter(
          (value) => value === "true" || value === true,
        );

        return (
          selectedOptions.length > 0 ||
          t("validation.error.code.AT_LEAST_ONE_OPTION")
        );
      },

      ...rules.validate,
    };
  }

  return rules;
}
